import { createClient } from "@supabase/supabase-js";

// Get Supabase URL and anon key from environment variables
// In Vite, these need to be prefixed with VITE_
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || "";
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || "";

// Use placeholder values that won't crash the app if Supabase is not configured
// The app will still work, but authentication will be disabled
const finalUrl = supabaseUrl || "https://placeholder.supabase.co";
const finalKey = supabaseAnonKey || "placeholder-key";

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn("Missing Supabase environment variables (VITE_SUPABASE_URL, VITE_SUPABASE_ANON_KEY). Authentication will not work until these are configured.");
}

// Try to create Supabase client, but don't crash if it fails
let supabase: ReturnType<typeof createClient>;
try {
  supabase = createClient(
    finalUrl,
    finalKey,
    {
      auth: {
        // Enable automatic token refresh (every ~55 minutes, rolling expiration)
        autoRefreshToken: !!supabaseUrl && !!supabaseAnonKey,
        // Persist session in localStorage for 90 days (extended for better UX)
        persistSession: !!supabaseUrl && !!supabaseAnonKey,
        // Detect session from URL (for OAuth callbacks)
        detectSessionInUrl: true,
        // Store session in localStorage (survives app updates/deployments)
        storage: typeof window !== 'undefined' ? window.localStorage : undefined,
        // Flow type: PKCE is more secure but implicit works too
        flowType: 'pkce',
        // Storage key for session (default is 'sb-<project-ref>-auth-token')
        storageKey: 'vintmap-session',
        // Enable debug mode in development to see auth issues
        debug: import.meta.env.DEV,
      },
      global: {
        headers: {
          'X-Client-Info': 'vintmap-web'
        }
      }
    }
  );
} catch (error) {
  console.error("Failed to create Supabase client:", error);
  // Create a minimal mock client that won't crash
  supabase = createClient(
    "https://placeholder.supabase.co",
    "placeholder-key",
    {
      auth: {
        autoRefreshToken: false,
        persistSession: false,
        detectSessionInUrl: false,
      },
    }
  );
}

export { supabase };
